// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import React, { type Node } from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import Logging from '@ta/common.logging';
import AuthZInfoQuery from './AuthZInfo.gql';

type ExternalProps = {|
  onError?: (error: any) => void,
  /** children is a function that accepts two parameters:
   * A 'loading' boolean indicating the query is in progress
   * An 'authZinfo' object containing the permissions once they are loaded. This object is empty while loading===true */
  children: (authzInfo: any, loading: boolean) => Node,
|};

type Props = {|
  ...ExternalProps,
  /** The logged in user id provided by the redux store */
  loggedInUserId: ?string,
|};

const WithAuthzInfo = ({ children, onError, loggedInUserId }: Props) => (
  <Query errorPolicy="all" query={AuthZInfoQuery} skip={!loggedInUserId} onError={onError}>
    {({ data = {}, loading, error }) => {
      if (error) {
        Logging.error(error);
      }
      const { authzInfo = {} } = data;
      return children(authzInfo, loading);
    }}
  </Query>
);

WithAuthzInfo.defaultProps = { onError: undefined };

const connectedComponent = connect<Props, ExternalProps, _, _, _, _>(
  (state, props: ExternalProps): Props => ({
    ...props,
    loggedInUserId: state.auth.loggedInUserId,
  }),
)(WithAuthzInfo);

export default connectedComponent;
